import React from "react";
import { Row, Col } from "antd";
import GeneralDetail from "./general-address";
import CoordinatorDetails from "./coordinator-details";
import WeatherReport from "./map-weather-report";
import PcpClinicInformations from "./pcp-clinic-information";
import KinsDetails from "./kins-details";
import { centricClientCheck } from "@utils/helpers";

type SectionKey = "generalDetail" | "coordinatorDetails" | "weatherReport" | "pcpClinicInformation" | "kinsDetails";

interface SectionsProps {
  contactDetailsData: any;
  activePanels: string[];
  setActivePanels: (panels: string[]) => void;
  pinChangeHandler: () => void;
  pinCardIds: string[];
  loadingForContact: boolean;
}

const Sections: React.FC<SectionsProps> = ({ contactDetailsData, activePanels, setActivePanels, pinChangeHandler, pinCardIds, loadingForContact }) => {
  const isCentric = centricClientCheck();

  const sectionMapping: Record<SectionKey, JSX.Element> = {
    generalDetail: (
      <GeneralDetail
        data={contactDetailsData?.generalAndAddress}
        dataCardId={contactDetailsData?.generalAndAddress?.datacardId}
        pinChangeHandler={pinChangeHandler}
        pinCardIds={pinCardIds}
        activeKey={activePanels}
        setActivePanels={setActivePanels}
        loading={loadingForContact}
      />
    ),
    coordinatorDetails: <CoordinatorDetails pinChangeHandler={pinChangeHandler} pinCardIds={pinCardIds} activeKey={activePanels} setActivePanels={setActivePanels} />,
    weatherReport: (
      <WeatherReport
        data={contactDetailsData?.generalAndAddress}
        dataCardId={contactDetailsData?.datacardIdForWeatherNearBy}
        pinChangeHandler={pinChangeHandler}
        pinCardIds={pinCardIds}
        activeKey={activePanels}
        setActivePanels={setActivePanels}
      />
    ),
    pcpClinicInformation: (
      <PcpClinicInformations
        data={contactDetailsData?.pcpAndClinicInformation}
        dataCardId={contactDetailsData?.pcpAndClinicInformation?.datacardId}
        pinChangeHandler={pinChangeHandler}
        pinCardIds={pinCardIds}
        activeKey={activePanels}
        setActivePanels={setActivePanels}
        loading={loadingForContact}
      />
    ),
    kinsDetails: (
      <KinsDetails
        data={contactDetailsData?.nextOfKinsInformation}
        dataCardId={contactDetailsData?.nextOfKinsInformation?.datacardId}
        pinChangeHandler={pinChangeHandler}
        pinCardIds={pinCardIds}
        activeKey={activePanels}
        setActivePanels={setActivePanels}
        loading={loadingForContact}
      />
    ),
  };

  const order: SectionKey[] = isCentric
    ? ["generalDetail", "coordinatorDetails", "pcpClinicInformation", "weatherReport", "kinsDetails"]
    : ["generalDetail", "weatherReport", "pcpClinicInformation", "kinsDetails"];

  return (
    <>
      {order.map((key: SectionKey, index) => (
        <Row style={{ marginBottom: 8 }} key={index}>
          <Col span={24}>{sectionMapping[key]}</Col>
        </Row>
      ))}
    </>
  );
};

export default Sections;
